$(function() {
  var DiscountType = {
    CURRENCY: 'CURRENCY',
    PERCENT: 'PERCENT'
  };

  var checkoutForm = $('.checkout-form');

  // Toggle order summary
  var summaryToggle = $('.summary-toggle');
  if (summaryToggle.length > 0) {
    summaryToggle.find('a').click(function() {
      if (summaryToggle.hasClass('open')) {
        $(this).html('Show summary');
        summaryToggle.removeClass('open');
      } else {
        $(this).html('Hide summary');
        summaryToggle.addClass('open');
      }
    });
  };

  var summaryPromoForm = $('.summary .promo form');
  var summarySubtotal = $('.summary .subtotal');
  var summarySubtotalAmount = summarySubtotal.find('.subtotal-amount');
  var summaryProrated = summarySubtotal.find('.subtotal-prorated');
  var summaryProratedDiscount = summaryProrated.find('.subtotal-discount');
  var summaryPromo = summarySubtotal.find('.subtotal-promo');
  var summaryPromoCode = summaryPromo.find('.subtotal-promo-code');
  var summaryPromoDiscount = summaryPromo.find('.subtotal-discount');
  var summaryClearPromo = summarySubtotal.find('.clear');
  var summaryTable = $('.summary-table');
  var summaryTotal = summaryTable.find('.total');

  var promoCodeInput = summaryPromoForm.find('input[name=code]');
  var promoLoading = summaryPromoForm.find('.loading');
  var submitPromoButton = summaryPromoForm.find('button[type=submit]');

  var validate = function() {
    var valid = true;

    promoCodeInput.setValid();
      
    var code = promoCodeInput.val();
    if (!code) {
      valid = false;
      promoCodeInput.setRequired();
    }

    return valid;
  };

  summaryPromoForm.on('submit', function(e) {
    e.preventDefault();

    if (!validate()) {
      return;
    }

    promoLoading.show();
    promoCodeInput.prop('disabled', true);
    submitPromoButton.prop('disabled', true);
    
    var opts = {
      success: function(discountCode) {
        if (discountCode.valid) {
          summaryPromoCode.text(discountCode.code);

          var totalDue = parseFloat(summarySubtotalAmount.text());
          var proratedDiscount = parseFloat(summaryProratedDiscount.text());
          if (!isNaN(proratedDiscount)) {
            totalDue -= proratedDiscount;
          };
          var discountAmount = parseFloat(discountCode.amount);

          var discount = 0;
          switch (discountCode.type) {
            case DiscountType.CURRENCY:
              discount = totalDue >= discountAmount ? discountAmount : 0;
              break;
            case DiscountType.PERCENT:
              discount = discountAmount <= 100 ? totalDue * (discountAmount / 100) : 0;
              break;
          }

          totalDue = totalDue - discount;

          summaryPromoDiscount.text(discount.toFixed(2));
          summaryTotal.text(totalDue.toFixed(2));
          promoCodeInput.val('');
          promoCodeInput.trigger('change');

          summarySubtotal.show();
          summaryPromo.show();
        } else {
          promoCodeInput.setInvalid();

          promoCodeInput.prop('disabled', false);
          submitPromoButton.prop('disabled', false);
        }
      },
      error: function(xhr, status, err) {
        AVNotify(err, 'danger');
        promoCodeInput.prop('disabled', false);
        submitPromoButton.prop('disabled', false);
      },
      complete: function() {
        promoLoading.hide();
      }
    };
    
    userResource.validateDiscount(promoCodeInput.val(), opts);
  });

  summaryClearPromo.on('click', function(e) {
    e.preventDefault();

    userResource.clearDiscount({
      success: function() {
        summaryPromoCode.text('');
        summaryPromoDiscount.text('');

        var subtotal = summarySubtotalAmount.text();

        var totalDue = subtotal;
        if (summaryProratedDiscount.text()) {
          totalDue -= parseFloat(summaryProratedDiscount.text());
        }
        
        summaryTotal.text(totalDue);

        if (subtotal === totalDue) {
          summarySubtotal.hide();
        }

        summaryPromo.hide();
        promoCodeInput.prop('disabled', false);
      },
      error: function(xhr, status, err) {
        AVNotify(err, 'danger');
      }
    });
  });

  promoCodeInput.on('keyup change input', function() {
    $(this).setValid();

    submitPromoButton.prop('disabled', !$(this).val());
  });
});